import { render, staticRenderFns } from "./TicketsReport.vue?vue&type=template&id=0f2437b4"
import script from "./TicketsReport.vue?vue&type=script&lang=js"
export * from "./TicketsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports